<script>
const horizonalLinePlugin = {
    id: 'horizontalLine',
    afterDraw: function (chartInstance) {

        var yValue;
        var yScale = chartInstance.scales["y-axis-0"];
        var canvas = chartInstance.chart;
        var ctx = canvas.ctx;
        var index;
        var line;
        var style;
        var fontSize = (120 / 114).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";
        ctx.textAlign = "center";
        var first = canvas.data.datasets[0].data;
        var second = canvas.data.datasets[1].data;



        var data = [first[0], first[1], first[2]];
        var data2 = [second[0], second[1], second[2]];

        for (var i = 0; i < data.length; i++) {
            var text = data[i];
            var text2 = data2[i];

            ctx.fillStyle = '#080808'

            ctx.fillText(Number(text).toLocaleString(undefined, {minimumFractionDigits: 2}), canvas.getDatasetMeta(0).data[i]._model.x, canvas.getDatasetMeta(0).data[i]._model.y - 10);
            ctx.fillText(Number(text2).toLocaleString(undefined, {minimumFractionDigits: 2}), canvas.getDatasetMeta(1).data[i]._model.x, canvas.getDatasetMeta(1).data[i]._model.y - 10);


        }


        // ctx.save();
        if (chartInstance.options.horizontalLine) {

            for (index = 0; index < chartInstance.options.horizontalLine.length; index++) {
                line = chartInstance.options.horizontalLine[index];

                if (!line.style) {
                    style = "#080808";
                } else {
                    style = line.style;
                }

                if (line.y) {
                    yValue = yScale.getPixelForValue(line.y);
                } else {
                    yValue = 0;
                }
                ctx.lineWidth = 3;


                if (yValue) {
                    window.chart = chartInstance;
                    ctx.beginPath();
                    ctx.moveTo(0, yValue);
                    ctx.lineTo(canvas.width, yValue);
                    ctx.strokeStyle = style;
                    ctx.stroke();
                }

                if (line.text) {
                    ctx.fillStyle = style;
                    ctx.fillText(line.text, 0, yValue + ctx.lineWidth);
                }
            }
            return;
        }
    }
}


import { Bar } from 'vue-chartjs'
import { EventBus } from "@/imports/EventBus";

export default {
    props: ['firstYearSelect', 'secondYearSelect', 'dataGrafic']
    ,
    methods: {
        async cargaInformation() {
            var today = new Date();
            this.yearComercial = today.getFullYear();
            this.firstYear = this.dataGrafic.PrimerAnio;
            this.secondYear = this.dataGrafic.SegundoAnio;

            var valorMaximo = Math.max(this.firstYear.Presupuesto, this.firstYear.Produccion, this.firstYear.Ingreso, this.secondYear.Presupuesto, this.secondYear.Produccion, this.secondYear.Ingreso);

            var valorEntre = valorMaximo / 10;

            var valorMax = valorMaximo + valorEntre;



            await this.addPlugin(horizonalLinePlugin);
            this.renderChart({
                labels: ['Presupuesto', 'Producción', 'Ingresos Acumulados'],
                datasets: [
                    {
                        label: 'Primer Año',
                        backgroundColor: '#3AA9E0',
                        data: [this.firstYear.Presupuesto, this.firstYear.Produccion, this.firstYear.Ingreso]
                    },
                    {
                        label: 'Segundo Año',
                        backgroundColor: '#000349',
                        data: [this.secondYear.Presupuesto, this.secondYear.Produccion, this.secondYear.Ingreso]
                    }

                ]
            },
                {

                    scales: {
                        xAxes: [{
                            stacked: false,
                            categoryPercentage: 0.5,

                        }],
                        yAxes: [{
                            stacked: false,
                            ticks: {
                                min: 6,
                                max: valorMax,
                                stepSize: valorEntre,
                                reverse: false,
                            },
                        }]
                    },
                    responsive: false,





                })

        },
        cargaInfo() {
            var data = [];
            data.push(this.firstYear);
            data.push(this.secondYear);

            return data;


        }

    },
    extends: Bar,
    mounted() {
        EventBus.$on("ChartCorporativoIngresoPorAnio", async () => {

            this.$root.$emit(
                "showLoading",
                "Cargando Ingreso por año de cumplimiento"
            );
            await this.cargaInformation();

            this.$root.$emit("hideLoading");

        });


    },
    data() {
        return {
        }
    }
}
</script>